import i18n, { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { ELanguage } from '../types'
import { allLang as allLangEn } from '../lang/en'
import { allLang as allLangRu } from '../lang/ru'
import { allLang as allLangUa } from '../lang/ua'
import { setDefaultLocale } from 'react-datepicker'

const defaultLang = ELanguage.en

const options: InitOptions = {
	debug: true,
	supportedLngs: Object.values(ELanguage),
	fallbackLng: defaultLang,
	interpolation: {
		escapeValue: false // not needed for react as it escapes by default
	},
	resources: {
		[ELanguage.en]: {
			translation: allLangEn
		},
		[ELanguage.ua]: {
			translation: allLangUa
		},
		[ELanguage.ru]: {
			translation: allLangRu
		}
	}
}

i18n
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init(options)

//TODO: remove after --- 'TRANSLATE FEATURE' is done (with activated LanguageDetector)
i18n.changeLanguage(defaultLang)
export default i18n
// set a global default locale for react-datepicker
setDefaultLocale(i18n.language)